
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/chip/chip.component.js'
      import type { DdsRemoveEvent } from '../../events/events'
import type { DdsSelectEvent } from '../../events/events'
      export type { DdsRemoveEvent } from '../../events/events'
export type { DdsSelectEvent } from '../../events/events'

      const tagName = 'dap-ds-chip'

      /**
 * `dap-ds-chip`
 * @summary A chip is a small status descriptor for UI elements.
 * @element dap-ds-chip
 * @title - Chip
 *
 * @event {{ value: string }} dds-remove - Fired when the chip is removed
 * @event {{ value?: string, selected: boolean }} dds-select - Fired when the chip is selected
 *
 * @csspart base - The base part
 * @csspart content-container - The container for the content
 * @csspart remove-button - The remove button
 *
 * @cssproperty --dds-chip-border-width - Border width of the chip
 * @cssproperty --dds-chip-border-style - Border style of the chip
 * @cssproperty --dds-chip-border-radius - Border radius of the chip
 * @cssProperty --dds-chip-border-color - Border color of the chip
 * @cssproperty --dds-chip-font-weight - Font weight of the chip
 * @cssproperty --dds-chip-line-height - Line height of the chip
 * @cssproperty --dds-chip-transition - Transition timing for chip interactions
 * @cssproperty --dds-chip-padding-sm - Padding for small chip size
 * @cssproperty --dds-chip-padding-lg - Padding for large chip size
 * @cssproperty --dds-chip-font-size-sm - Font size for small chip size
 * @cssproperty --dds-chip-font-size-lg - Font size for large chip size
 * @cssproperty --dds-chip-background-color - Background color of the chip
 * @cssproperty --dds-chip-text-color - Text color of the chip
 * @cssproperty --dds-chip-hover-background-color - Background color of the chip on hover
 * @cssproperty --dds-chip-active-background-color - Background color of the chip when active
 * @cssproperty --dds-chip-selected-background-color - Background color of the selected chip
 * @cssproperty --dds-chip-selected-text-color - Text color of the selected chip
 * @cssproperty --dds-chip-selected-border-color - Border color of the selected chip
 * @cssproperty --dds-chip-disabled-background-color - Background color of the disabled chip
 * @cssproperty --dds-chip-disabled-text-color - Text color of the disabled chip
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsRemove: 'dds-remove' as EventName<DdsRemoveEvent>,
onDdsSelect: 'dds-select' as EventName<DdsSelectEvent>
        },
        displayName: "DapDSChip"
      })

      export default reactWrapper
    